import { render, staticRenderFns } from "./PasswordResetSuccess.vue?vue&type=template&id=ef21a0be&scoped=true"
import script from "./PasswordResetSuccess.vue?vue&type=script&lang=js"
export * from "./PasswordResetSuccess.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetSuccess.vue?vue&type=style&index=0&id=ef21a0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef21a0be",
  null
  
)

export default component.exports